import React, { useState } from 'react';

import './dropdown.text.scss';
import {DropDownLog} from "../../services/interactions/elements/dropdown";

function DropdownText({options, label, placeholder, value, onChange, onClick, transparent, icon}){
    const [isOpen, setOpen] = useState(false);
    const currentValue = options.find(o => o.value === value);

    const getIconColor = (option) => {
        if (!option.color) {
            return {};
        }
        let style = {
            'background': option.color
        };
        if (option.borderColor) {
            style['border'] = '3px solid ' + option.borderColor;
        }
        return style;
    };

    const toggleOpen = () => {
        if (onClick) {
            onClick(!isOpen);
        }
        setOpen(!isOpen);
    }

    return (
        <div className={`_dropdownContainer ${isOpen ? 'open' : ''}`}>
            {
                isOpen ? <div className="_dropdownOverlay" onClick={toggleOpen}></div> : ''
            }
            <div className="_dropdown" onClick={toggleOpen}>
                {
                    icon? <span className="_iconStatus" style={getIconColor(currentValue)}>
                            { value? '' : 'A' }
                        </span> : <span className="material-icons">filter_list</span>
                }
                <span className="_text">
                    Filter
                </span>
                <p>
                    {!!currentValue && currentValue.label ? currentValue.label : ''}
                </p>
                <i className="material-icons">
                    keyboard_arrow_down
                </i>
            </div>
            <div className="_options">
                {
                    label ? 
                    <p className="label">{label}</p>
                    : ''
                }
                {
                    options.map((option, index) => {
                        const selected = option.value === value;
                        return (
                            <div className={`_option ${selected ? 'selected' : ''}`} onClick={() => onChange(option)} key={index}>
                                <div className="check">
                                    {
                                        icon?  <span className="_iconStatus" style={getIconColor(option)} >
                                                { index === 0 ? 'A' : '' }
                                            </span> : <i className="material-icons">check</i>
                                    }
                                </div>
                                <p>
                                    {option.label}
                                </p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default DropDownLog(DropdownText);
